var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33331 12.0002C9.33331 11.632 9.63179 11.3335 9.99998 11.3335C10.3682 11.3335 10.6666 11.632 10.6666 12.0002C10.6666 12.3684 10.3682 12.6668 9.99998 12.6668C9.63179 12.6668 9.33331 12.3684 9.33331 12.0002Z",
    stroke: "#ABBACE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 12.0002C5.33331 11.632 5.63179 11.3335 5.99998 11.3335C6.36817 11.3335 6.66665 11.632 6.66665 12.0002C6.66665 12.3684 6.36817 12.6668 5.99998 12.6668C5.63179 12.6668 5.33331 12.3684 5.33331 12.0002Z",
    stroke: "#ABBACE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33331 8.00016C9.33331 7.63197 9.63179 7.3335 9.99998 7.3335C10.3682 7.3335 10.6666 7.63197 10.6666 8.00016C10.6666 8.36835 10.3682 8.66683 9.99998 8.66683C9.63179 8.66683 9.33331 8.36835 9.33331 8.00016Z",
    stroke: "#ABBACE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 8.00016C5.33331 7.63197 5.63179 7.3335 5.99998 7.3335C6.36817 7.3335 6.66665 7.63197 6.66665 8.00016C6.66665 8.36835 6.36817 8.66683 5.99998 8.66683C5.63179 8.66683 5.33331 8.36835 5.33331 8.00016Z",
    stroke: "#ABBACE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33331 4.00016C9.33331 3.63197 9.63179 3.3335 9.99998 3.3335C10.3682 3.3335 10.6666 3.63197 10.6666 4.00016C10.6666 4.36835 10.3682 4.66683 9.99998 4.66683C9.63179 4.66683 9.33331 4.36835 9.33331 4.00016Z",
    stroke: "#ABBACE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 4.00016C5.33331 3.63197 5.63179 3.3335 5.99998 3.3335C6.36817 3.3335 6.66665 3.63197 6.66665 4.00016C6.66665 4.36835 6.36817 4.66683 5.99998 4.66683C5.63179 4.66683 5.33331 4.36835 5.33331 4.00016Z",
    stroke: "#ABBACE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.de589d048d76338eb20c29443036eb81.svg";
export { ForwardRef as ReactComponent };